export default __webpack_public_path__ + "static/studio-slider-8-8cf2bd90bf7f2f36e01b7dc2166a0578.png";